import { useRef, useEffect, useState } from "react";
import "./WhyUsBanner.css";
import about_banner from '../../assets/whyus_banner.png';
import { Link } from 'react-router-dom';

export default function WhyUsBanner() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.05 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`whyus-banner ${inView ? "whyus-in-view" : ""}`}>

      {/* Right photo with gradient fade */}
      <div className="whyus-photo-wrap">
        <img src={about_banner} alt="" className="whyus-photo" />
        <div className="whyus-photo-fade" />
      </div>

      {/* Left content */}
      <div className="whyus-inner">
        <div className="whyus-content">
          <h1 className="whyus-heading">About Us</h1>

          <p className="whyus-para">
            <Link to="/" className="whyus-para-link">Watt &amp; Wattle</Link> is a Melbourne-based solar and battery company focused on
            helping local households reduce electricity costs, store more of their own
            energy, and build a more reliable home energy system.
          </p>

          <p className="whyus-para">
            We work with proven brands, licensed electricians, and practical solutions
            designed around each home's real energy needs.
          </p>

          <Link to="/enquiry" className="whyus-btn">Get a Quote</Link>

          {/* Stats row */}
          <div className="whyus-stats">
            <div className="whyus-stat">
              <div className="whyus-stat-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 1l2.39 4.84 5.34.78-3.87 3.77.91 5.32L10 13.27l-4.77 2.44.91-5.32L2.27 6.62l5.34-.78z"/>
                </svg>
              </div>
              <div>
                <div className="whyus-stat-title">5.0 Rating</div>
                <div className="whyus-stat-sub">customer reviews</div>
              </div>
            </div>

            <div className="whyus-stat-divider" />

            <div className="whyus-stat">
              <div className="whyus-stat-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div>
                <div className="whyus-stat-title">Hundreds of Homes</div>
                <div className="whyus-stat-sub">Across Melbourne</div>
              </div>
            </div>

            <div className="whyus-stat-divider" />

            <div className="whyus-stat">
              <div className="whyus-stat-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div>
                <div className="whyus-stat-title">Licensed &amp; Insured</div>
                <div className="whyus-stat-sub">Local Electricians</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
